<template>
  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :layout="layout" :page-size="pageSize" :total="total" :pager-count="pagerCount">
  </el-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 15, 20, 50];
      }
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit('update:page', val);
      }
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit('update:limit', val);
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(val)
      this.pageSize = val;
      const maxPage = Math.ceil(this.total / val);
      console.log(maxPage, this.currentPage)
      if (maxPage >= this.currentPage) {
        this.$emit('pagination', { page: this.currentPage, limit: val });
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit('pagination', { page: val, limit: this.limit });
    }
  }
};
</script>
